import { immutableZkEvm } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createImmutableZkEvmChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createImmutableZkEvmChainCustom({
    client: createClient({
      chain: immutableZkEvm,
      httpRpcs: immutableZkEvmHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Immutable explorer',
      baseUrl: 'https://explorer.immutable.com',
      apiBaseUrl: 'https://explorer.immutable.com/api',
      proxyUrl,
    }),
  })

type CreateImmutableZkEvmChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createImmutableZkEvmChainCustom = ({
  client,
  explorer,
}: CreateImmutableZkEvmChainCustomParameters): Chain => ({
  id: 13_371,
  network: 'immutable-zk-evm',
  name: 'Immutable zkEVM',
  nativeToken: {
    name: 'Immutable',
    symbol: 'IMX',
    decimals: 18,
    currency: {
      symbol: 'IMX',
      type: 'CryptoCurrency',
      id: 'immutable-x',
      name: 'Immutable',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x3a0c2ba54d6cbd3121f01b96dfd20e99d1696c9d',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'immutable',
  defillamaId: undefined,
})

export const immutableZkEvmHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.immutable.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 5000n,
  },
  {
    url: 'https://immutable.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const immutableZkEvmWebsocketRpcUrls: string[] = [
  'wss://immutable-zkevm.drpc.org',
]
